import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SortDirection, sortData, getNextSortDirection } from '../../core/utils/sort-utils/sort-utils';
import {TableColumn} from '../models/table-column';

export interface SortState {
  columnName: string;
  direction: SortDirection;
}

@Injectable({
  providedIn: 'root'
})
export class SortService {
  private sortStateSubject = new BehaviorSubject<SortState | null>(null);
  public sortState$ = this.sortStateSubject.asObservable();

  constructor() {}

  // Obtener el estado actual del ordenamiento
  getCurrentSortState(): SortState | null {
    return this.sortStateSubject.value;
  }

  // Aplicar ordenamiento a una columna específica
  applySort<T>(data: T[], column: TableColumn, currentDirection: SortDirection): { sortedData: T[], newDirection: SortDirection } {
    const newDirection = getNextSortDirection(currentDirection);

    // Si la nueva dirección es null, resetear el ordenamiento
    if (newDirection === null) {
      this.sortStateSubject.next(null);
      return { sortedData: [...data], newDirection: null };
    }

    // Aplicar el nuevo ordenamiento
    const sortedData = sortData(data, { column, direction: newDirection });

    // Actualizar el estado
    this.sortStateSubject.next({ columnName: column.name, direction: newDirection });

    return { sortedData, newDirection };
  }

  // Resetear el ordenamiento
  resetSort(): void {
    this.sortStateSubject.next(null);
  }

  // Verificar si una columna está ordenada
  isColumnSorted(columnName: string): SortDirection | null {
    const currentState = this.sortStateSubject.value;
    return currentState?.columnName === columnName ? currentState.direction : null;
  }

  // Obtener la dirección de ordenamiento de una columna específica
  getColumnSortDirection(columnName: string): SortDirection {
    const currentState = this.sortStateSubject.value;
    return currentState?.columnName === columnName ? currentState.direction : null;
  }
}
